export enum InboxStatus {
    New,
    Processing,
    NoRfqFound,
    ReadyToValidate,
    DocHeaderCreated,
    UploadWorkbookCreated,
    SkipBySender,
    ToValidateDeleted,
    ImportFailed,
    PortalRequestLinkFound
}